<template>
  <b-form-input
    v-on:keyup="debouncedChangeValues"
    @keydown.enter.native="enterEvent"
    type="text"
    @focus="onFocus"
    @blur="onBlur"
    pattern="\d*"
    ref="inputField"
    v-model.lazy="myModel"
    @input="onInput"
    @wheel.prevent
    placeholder="Type your answer here..."
  />
</template>

<script>
import { debounce } from 'lodash';

export default {
  props: ["model", "name"],
  data() {
    return {
      inputFocus: false,
      myModel: "",
    };
  },
  computed: {
    debouncedChangeValues() {
      return debounce(this.changeValues, 500);
    },
  },
  watch: {
    model(newVal) {
      const numericVal = parseFloat(newVal);
      this.myModel =
        !isNaN(numericVal) && numericVal >= 0
          ? `$${this.numberWithCommas(Math.round(numericVal))}`
          : "";
    },
  },
  methods: {
    onInput(e) {
      const raw = e.target.value.replace(/[^\d]/g, "");
      this.myModel = raw || "";
    },
    focus() {
      this.$refs.inputField.focus();
    },
    enterEvent() {
      this.$emit("enterEvent", "enter");
    },
    changeValues() {
      this.$emit("changeValue", this.myModel, this.name);
    },
    onFocus() {
      this.inputFocus = true;
      if (this.myModel) {
        this.myModel = this.unmaskMoneyValue(this.myModel);
      }
    },
    onBlur() {
      this.inputFocus = false;

      const cleaned = this.unmaskMoneyValue(this.myModel);
      const numericVal = parseFloat(cleaned);
      if (!isNaN(numericVal)) {
        this.myModel = `$${this.numberWithCommas(Math.round(numericVal))}`;
      } else {
        this.myModel = "";
      }
    },
    unmaskMoneyValue(val) {
      if (typeof val === "string") {
        const cleaned = val.replace(/[$,]/g, "");
        return isNaN(parseFloat(cleaned)) ? "0" : cleaned;
      }
      return typeof val === "number" ? val.toString() : "0";
    },
    numberWithCommas(x) {
      const num = parseInt(x);
      if (isNaN(num)) return "0";
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
